define('plugin/promotion/view/PromotionModuleItemView',['require','plugin/promotion/view/PromotionItemView','lib/theme/ThemeSettings'],function (require) {

    var PromotionItemView = require('plugin/promotion/view/PromotionItemView');

    var ThemeSettings = require('lib/theme/ThemeSettings');
    /**
     * Promotion module item view
     *
     * @class PromotionModuleItemView
     */
    return PromotionItemView.extend({

        template: '#promotion_module_item_view',

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#promotion_module_item_view_list';
            }
            return this.template;
        }

    });

});
